// extracted by mini-css-extract-plugin
export default {"itemWrapper":"_6412c17","swiperItem":"_bc9697ee","itemInner":"_edec3fda","heartButton":"_2aab0e8d","heart":"_7a45709b","swiperWrapper":"_4a228708","loading":"_440726d7"};